import {combineReducers} from 'redux'
import currencies from './currencies'
import cryptoCurrencies from './cryptoCurrencies'
import rates from './rates'
import cryptoRates from './cryptoRates'
import ratesHistory from './ratesHistory'
import cryptoRatesHistory from './cryptoRatesHistory'
import weeklyCryptoRatesHistory from './weeklyCryptoRatesHistory'
import mostWanted from './mostWanted'
import cryptoMostWanted from './cryptoMostWanted'
import calculatedRate from './calculatedRate'
import blogPosts from './blogPosts'
import contactForm from './contactForm'
import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
	currencies,
	cryptoCurrencies,
	rates,
	cryptoRates,
	ratesHistory,
	cryptoRatesHistory,
	weeklyCryptoRatesHistory,
	mostWanted,
	cryptoMostWanted,
	calculatedRate,
	blogPosts,
	contactForm,
	form: formReducer
})

export default rootReducer